import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'
import {
  FindQueryConfig,
  ProjectListResonseData,
  SearchQueryConfig,
  TableItemConfig,
} from '@pt/api/vrecord/project/index.type'
import { ResponseData } from 'request'

export function projectList(data?: SearchQueryConfig): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/list`,
    method: 'get',
    params: data,
  })
}

export function projectSave(data: Partial<TableItemConfig>): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/save`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

export function projectDel(ids: number | string): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/del?ids=${ids}`,
    method: 'POST',
  })
}

// 锁定
export function projectLock(data: { pid: number }): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/lock?pid=${data.pid}`,
    method: 'post',
  })
}

// 解锁
export function projectUnLock(data: { pid: number }): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/unlock?pid=${data.pid}`,
    method: 'post',
  })
}

// 项目详情
export function projectDetail(id: number): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/detail?id=${id}`,
    method: 'get',
  })
}

export function projectUpdate(data: TableItemConfig): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/update`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

export function projectCopy(pid: number, name: string): AxiosPromise {
  return request({
    url: `${v2Host}/vrecord/project/copy`,
    method: 'post',
    data: {
      pid,
      name,
    },
  })
}

export function projectFind(
  data: FindQueryConfig,
): AxiosPromise<ResponseData<ProjectListResonseData>> {
  return request({
    url: `${v2Host}/vrecord/project/find`,
    method: 'get',
    params: data,
  })
}
